export enum LocalStorageKey {
  TOKEN = 'token',
  USER = 'user',
  LOGIN_REDIRECT = 'redirectPath'
}

export type GetMarketplaceProfileResponse = {
  biography: string,
  email: string,
  hasApprovedAccount: boolean,
  locale: string,
  name: string,
  timeZone: string,
  tradeName: string,
  urlPhoto?: string,
  website: string
}
